import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { CircleUser } from 'lucide-react';

export default function AppHeader() {
  const [email, setEmail] = useState<string | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/auth/me');
        if (!res.ok) return;
        const data = await res.json();
        setEmail(data.email || null);
        const roles: string[] = data.roles || [];
        setIsAdmin(roles.includes('admin'));
      } catch {}
    })();
  }, [location.pathname]);

  async function onLogout() {
    try {
      await fetch('/auth/logout', { method: 'POST' });
    } finally {
      navigate('/');
    }
  }

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background">
      <div className="container mx-auto h-14 flex items-center justify-between px-4">
        <Link to="/home" className="font-semibold">tvbot</Link>
        <nav className="flex items-center gap-4">
          <Button asChild variant="ghost" size="sm"><Link to="/home">Home</Link></Button>
          {isAdmin && (
            <Button asChild variant="ghost" size="sm"><Link to="/admin/users">Users</Link></Button>
          )}
        </nav>
        <div className="flex items-center gap-3">
          {email ? (
            <>
              <CircleUser className="w-5 h-5" />
              <span className="text-sm text-muted-foreground hidden sm:inline">{email}</span>
              <Button size="sm" variant="outline" onClick={onLogout}>Logout</Button>
            </>
          ) : (
            <Button asChild size="sm"><Link to="/">Login</Link></Button>
          )}
        </div>
      </div>
    </header>
  );
}
